import { DlfMatcherTypes } from "../../types/rules/DlfMatcherTypes";
import { MatcherProperties } from "./Matcher";

type DlfMatcherProperties = {
  fieldName: string;
  position: number;
  discriminator: DlfMatcherTypes;
  ocrConfidenceThreshold: number;
} & Omit<MatcherProperties, "discriminator">;

abstract class DlfMatcher implements DlfMatcherProperties {
  abstract discriminator: DlfMatcherTypes;
  abstract fieldName: string;

  abstract reusable: boolean;
  abstract position: number;
  abstract threshold: number;
  abstract ocrConfidenceThreshold: number;

  /**
   * The unique value between all Matcher types
   */
  abstract getMatcherId(): string;

  abstract getDiscriminator(): DlfMatcherTypes;

  abstract isConfigured(): boolean;
  abstract clear(): void;

  toggleReusable(): boolean {
    this.setReusable(!this.getReusable());
    return this.getReusable();
  }
  getReusable(): boolean {
    return this.reusable;
  }
  setReusable(value: boolean): void {
    this.reusable = value;
  }

  supportsAllowEmpty(): boolean {
    return false;
  }

  abstract toMatcherData(): DlfMatcherProperties;
}

export { DlfMatcher, DlfMatcherProperties };
